// API ENDPOINTS
export const API_VERSION = process.env.REACT_APP_API_VERSION || 'v2';
export const API_URL = new URL('/api/' + API_VERSION + '/', window.app_api_url || process.env.REACT_APP_API_URL);
export const OHSOME_STATS_BASE_URL =
  process.env.REACT_APP_OHSOME_STATS_BASE_URL;
export const OHSOME_STATS_API_URL =
  process.env.REACT_APP_OHSOME_STATS_API_URL;
// APPLICATION SETTINGS
export const DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LOCALE || 'zh_CN';
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || '';
export const PROJECTCARD_CONTRIBUTION_SHOWN_THRESHOLD = process.env.REACT_APP_PROJECTCARD_CONTRIBUTION_SHOWN_THRESHOLD || 5;
export const INTERMEDIATE_LEVEL_COUNT = Number(process.env.REACT_APP_TM_MAPPER_LEVEL_INTERMEDIATE) || 250;
export const ADVANCED_LEVEL_COUNT = Number(process.env.REACT_APP_TM_MAPPER_LEVEL_ADVANCED) || 500;
export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN || '';
export const ENABLE_SERVICEWORKER = process.env.REACT_APP_ENABLE_SERVICEWORKER || 0;
export const MAX_AOI_AREA = Number(process.env.REACT_APP_MAX_AOI_AREA) || 5000;
export const MAX_FILESIZE = parseInt(process.env.REACT_APP_MAX_FILESIZE) || 10000000; // bytes
export const PROJECT_CREATE_MIN_DRAWING_LEVEL =
  Number(process.env.REACT_APP_PROJECT_CREATE_MIN_DRAWING_LEVEL) || 1;
export const PROJECT_CREATE_MAX_DRAWING_LEVEL =
  Number(process.env.REACT_APP_PROJECT_CREATE_MAX_DRAWING_LEVEL) || 22;
export const PROJECT_CREATE_MAX_TASKS_NUMBER =
  Number(process.env.REACT_APP_PROJECT_CREATE_MAX_TASKS_NUMBER) || 16384;
export const PROJECT_CREATE_DEFAULT_DRAWING_LEVEL =
  Number(process.env.REACT_APP_PROJECT_CREATE_DEFAULT_DRAWING_LEVEL) || 11;
export const PROJECT_CREATE_TINY_TASK_RATIO =
  Number(process.env.REACT_APP_PROJECT_CREATE_TINY_TASK_RATIO) || 0.1;

// ORGANISATIONAL INFORMATION
export const ORG_NAME = process.env.REACT_APP_ORG_NAME;
export const ORG_CODE = process.env.REACT_APP_ORG_CODE;
export const ORG_URL = process.env.REACT_APP_ORG_URL || '';
export const ORG_LOGO = process.env.REACT_APP_ORG_LOGO || '';
export const HOMEPAGE_IMG_HIGH = process.env.REACT_APP_HOMEPAGE_IMG_HIGH || '';
export const HOMEPAGE_IMG_LOW = process.env.REACT_APP_HOMEPAGE_IMG_LOW || '';
export const OSM_CLIENT_ID = process.env.REACT_APP_OSM_CLIENT_ID || '';
export const OSM_REDIRECT_URI = window.osm_redirect_uri || process.env.REACT_APP_OSM_REDIRECT_URI || '';
export const ORG_PRIVACY_POLICY_URL = process.env.REACT_APP_ORG_PRIVACY_POLICY_URL || '';
export const OSM_REGISTER_URL = window.app_osm_register_url || process.env.REACT_APP_OSM_REGISTER_URL;
export const ORG_TWITTER = process.env.REACT_APP_ORG_TWITTER;
export const ORG_FB = process.env.REACT_APP_ORG_FB;
export const ORG_INSTAGRAM = process.env.REACT_APP_ORG_INSTAGRAM;
export const ORG_YOUTUBE = process.env.REACT_APP_ORG_YOUTUBE;
export const ORG_GITHUB = process.env.REACT_APP_ORG_GITHUB;
export const MATOMO_ID = process.env.REACT_APP_MATOMO_ID || '';
export const SERVICE_DESK = process.env.REACT_APP_SERVICE_DESK || '';
export const IMAGE_UPLOAD_SERVICE = process.env.REACT_APP_IMAGE_UPLOAD_API_URL || '';
export const TM_DEFAULT_CHANGESET_COMMENT = process.env.REACT_APP_TM_DEFAULT_CHANGESET_COMMENT || '#project';
export const HOMEPAGE_VIDEO_URL = process.env.REACT_APP_HOMEPAGE_VIDEO_URL || '';
// Sentry.io DSN
export const SENTRY_FRONTEND_DSN = process.env.REACT_APP_SENTRY_FRONTEND_DSN;

// OSM API and Editor URLs
export const OSM_SERVER_URL = window.osm_server_url || process.env.REACT_APP_OSM_SERVER_URL;
export const OSM_SERVER_API_URL = process.env.REACT_APP_OSM_SERVER_API_URL;
export const ID_EDITOR_URL = process.env.REACT_APP_ID_EDITOR_URL;
export const POTLATCH2_EDITOR_URL = process.env.REACT_APP_POTLATCH2_EDITOR_URL;
export const RAPID_EDITOR_URL = process.env.REACT_APP_RAPID_EDITOR_URL;
export const EXPORT_TOOL_S3_URL = process.env.REACT_APP_EXPORT_TOOL_S3_URL || '';
export const ENABLE_EXPORT_TOOL = process.env.REACT_APP_ENABLE_EXPORT_TOOL || '';
export const DEFAULT_VALIDATOR_TEAM_ID = process.env.REACT_APP_DEFAULT_VALIDATOR_TEAM_ID || null;

export const TASK_COLOURS = {
  READY: '#fff',
  LOCKED_FOR_MAPPING: '#fff',
  MAPPED: '#ade6ef',
  LOCKED_FOR_VALIDATION: '#ade6ef',
  VALIDATED: '#40ac8c',
  INVALIDATED: '#fceca4',
  BADIMAGERY: '#d8dae4',
  PRIORITY_AREAS: '#efd1d1',
};

export const CHART_COLOURS = {
  red: '#d73f3f',
  green: '#3e9c67',
  blue: '#3389D6',
  orange: '#f09733',
  white: '#fff',
  gray: '#C9C9C9',
};


function loadBasemapConfig() {
  let config = null;

  if (window.basemap_config && (window.basemap_config.styles || window.basemap_config.options)) {
    return parseBasemapConfig(window.basemap_config);
  }

  try {
    config = require('./basemap-config.json');
    if (config && (config.styles || config.options)) {
      return parseBasemapConfig(config);
    }
  } catch (e) {
  }

  const envConfig = process.env.REACT_APP_BASEMAP_CONFIG;
  if (envConfig) {
    try {
      config = JSON.parse(envConfig);
      if (config && (config.styles || config.options)) {
        return parseBasemapConfig(config);
      }
    } catch (e) {
      console.error('Failed to parse REACT_APP_BASEMAP_CONFIG:', e);
    }
  }

  return [
    { label: 'default', value: 'bright-v9' }
  ];
}

function parseBasemapConfig(config) {
  const styles = config.styles || {};
  const options = config.options || [];

  return options.map(option => {
    if (typeof option.value === 'string' && styles[option.value]) {
      return { ...option, value: styles[option.value] };
    }
    return option;
  });
}

export const BASEMAP_OPTIONS = loadBasemapConfig();

export const MAP_STYLE = MAPBOX_TOKEN
  ? `mapbox://styles/mapbox/${BASEMAP_OPTIONS[0].value}`
  : BASEMAP_OPTIONS[1].value;
export const MAPBOX_RTL_PLUGIN_URL =
  process.env.PUBLIC_URL + '/mapbox-gl-rtl-text.js';

export const UNDERPASS_URL = process.env.REACT_APP_UNDERPASS_URL;

export const DROPZONE_SETTINGS = {
  accept: {
    'image/*': ['.jpeg', '.jpg', '.png', '.webp', '.gif'],
  },
  multiple: false,
  maxSize: 256000,
  // noClick is needed to avoid file picker dialogs when switching between `Write` and `Preview` in `CommentInputField`
  // At time of writing, this workaround is only needed on Chromium based browsers.
  noClick: true,
};

// TM_DEFAULT_CHANGESET_COMMENT without '#'
export const defaultChangesetComment = TM_DEFAULT_CHANGESET_COMMENT.replace('#', '');
